
import React from 'react';
import { COLORS } from '../constants';

const ContactSection: React.FC = () => {
  return (
    <section id="contact" className="py-12 md:py-16 bg-[#F8FAFA]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-20">
        <div className="bg-[#1E1E1E] rounded-[0.8rem] p-8 md:p-20 relative overflow-hidden flex flex-col items-center text-center reveal-item">
          {/* Decorative background elements */}
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-emerald-500/10 blur-[100px]" />
          <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full bg-emerald-500/10 blur-[100px]" />

          <h2 className="text-white text-[clamp(2rem,8vw,4.5rem)] font-bold leading-tight mb-8 md:mb-10 relative z-10 reveal-item" style={{ transitionDelay: '0.1s' }}>
            Let's start your <br />
            <span className="text-emerald-500">renewable journey</span>
          </h2>
          
          <p className="text-gray-400 text-base md:text-xl max-w-2xl mb-10 md:mb-12 relative z-10 reveal-item" style={{ transitionDelay: '0.2s' }}>
            Join thousands of businesses and homeowners who have already switched to a cleaner, more profitable energy future with Novus.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 md:gap-6 relative z-10 w-full justify-center reveal-item" style={{ transitionDelay: '0.3s' }}>
             <input 
               type="email" 
               placeholder="Enter your email address" 
               className="bg-white/5 border border-white/10 rounded-[0.8rem] px-6 md:px-8 py-4 md:py-5 text-white outline-none focus:border-emerald-500 transition-colors w-full max-w-md"
             />
             <button 
               className="bg-emerald-500 hover:bg-emerald-400 text-black font-extrabold px-8 md:px-10 py-4 md:py-5 rounded-[0.8rem] transition-all hover:scale-105 active:scale-95 shadow-xl shadow-emerald-500/20"
             >
               Get Started Now
             </button>
          </div>

          <div className="mt-12 md:mt-20 flex flex-wrap justify-center gap-6 md:gap-12 text-white/50 text-[10px] md:text-sm font-bold uppercase tracking-widest relative z-10 reveal-item" style={{ transitionDelay: '0.4s' }}>
            <div className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
              Global Support
            </div>
            <div className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
              24/7 Monitoring
            </div>
            <div className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
              Certified Experts
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
